<template>
  <span class="plan-joined-member-bar ym-mw-component-fixed-max"
        :class="{ 'switch': isSwitching }"
        v-if="currMemberDesc"
  >
    {{ currMemberDesc }}
  </span>
</template>

<script>
  export default {
    name: 'PlanJoinedMemberBar',
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        // 当前展示的用户加入提示
        currMemberDesc: '',
        // 待展示用户名列表
        willShowMember: [],
        // 是否切换
        isSwitching: false,
      };
    },
    watch: {
      list(val) {
        this.willShowMember = JSON.parse(JSON.stringify(val));
      },
      willShowMember() {
        setTimeout(() => {
          this.fetchWillShowDesc();
        }, this.fetchSwitchTime(4000, 8000));
      },
    },
    methods: {
      // 取出接下来要展示的提示
      fetchWillShowDesc() {
        this.isSwitching = true;
        if (this.willShowMember.length === 0) {
          this.willShowMember = JSON.parse(JSON.stringify(this.list));
        }
        const { length } = this.willShowMember;
        // 生成随机数组下标
        const randomIndex = parseInt(Math.random() * length, 10);
        // 获取对应的用户名
        const randomMember = this.willShowMember[randomIndex];
        // 组装展示的描述语
        this.currMemberDesc = `${randomMember}刚刚加入了学习计划`;
        // 从待展示数组中移除当前用户名
        this.willShowMember.splice(randomIndex, 1);
        setTimeout(() => {
          this.isSwitching = false;
        }, 200);
      },
      // 描述语切换的时间间隔
      fetchSwitchTime(min, max) {
        return parseInt(((Math.random() * ((max - min) + 1)) + min), 10);
      },
    },
    created() {
      this.willShowMember = this.list;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .plan-joined-member-bar {
    width: fit-content;
    position: fixed;
    bottom: 120px;
    margin: 0 auto;
    padding: 14px 24px;
    box-sizing: border-box;
    background: fade(#333, 60%);
    font-size: @font-size-small;
    line-height: 1;
    color: @color-gray-lighter;
    border-radius: 25px;
    &.switch {
      animation: 2s fadein ease;
    }
    @keyframes fadein{
      0% {
        opacity: 0;
      }
      100%{
        opacity: 1;
      }
    }
  }

</style>
